<template lang="pug">
div
  .sgbox.sg.aaa
    .gbox
      #preloader(v-if="gameLaunching")
        #loader
      .ggl
        a(href="javascript:void(0)" @click='launchGame')
          img(src='assets/img/product-thumb/slot/spade-gaming.jpg')
          span SpadeGaming
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      mobileDevice: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  mounted(){
    // window.scroll(0,0)
    this.getMobile()
    // this.getProviderGameOfflist()
  },
  methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    // getProviderGameOfflist(){
    //   if (this.sessionToken) {
		// 		var vm = this
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let provider_code = "SPADE"
    //     this.$store
    //       .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					this.offList = response.data
    //           this.getGameList()
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		this.getGameList()
		// 	}
    // },
    // getGameList(){
    //   var vm = this
    //   this.pageLoading = true
		// 	var url = config.getSGGamelist()
    //   this.$http.get(url).then(
    //     successResponse => {
    //       if(successResponse){
    //         if (typeof successResponse.data.status == "string") {
    //           this.feedback.success = successResponse.status == "200";
    //         } else {
    //           this.feedback.success = successResponse.status == 200;
    //         }
    //         this.feedback.status = successResponse.status;
    //         if (this.feedback.success == true) {
    //           var _0xde64=["\x67\x61\x6D\x65\x4C\x69\x73\x74","\x67\x61\x6D\x65\x5F\x6C\x69\x73\x74","\x64\x61\x74\x61","\x69\x6D\x61\x67\x65\x55\x72\x6C","\x67\x61\x6D\x65\x5F\x6C\x6F\x67\x6F\x5F\x75\x72\x6C","\x72\x74\x70","\x74\x6F\x46\x69\x78\x65\x64","\x70\x72\x65\x63\x69\x73\x69\x6F\x6E","\x72\x61\x6E\x64\x6F\x6D","\x6D\x61\x78","\x6D\x69\x6E","\x66\x6F\x72\x45\x61\x63\x68"];this[_0xde64[0]]= successResponse[_0xde64[2]][_0xde64[1]];eval(function(p,a,c,k,e,d){e=function(c){return c.toString(36)};if(!''.replace(/^/,String)){while(c--){d[c.toString(a)]=k[c]||c.toString(a)}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('e[a[3]]=j[a[2]][a[4]];e[a[0]][a[i]](h(d){d[a[5]]=g((f[a[8]]()*(b[a[9]]-b[a[c]])+b[a[c]])[a[6]](b[a[7]])*1)[a[6]](2)})',20,20,'||||||||||_0xde64|vm|10|_0x4066x1|this|Math|parseFloat|function|11|successResponse'.split('|'),0,{}))
    //           let updateList = [].concat(
    //             this.gameList.filter(obj1 => this.offList.every(obj2 => obj1.gameCode !== obj2.game_id)),
    //             this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_id !== obj1.gameCode))
    //           )
    //           this.items = _.chunk(updateList, 30);
    //           this.listToDisplay = this.items[0]
    //           this.pageLoading = false
    //         } else {
    //           this.pageLoading = false
    //         }
    //       }else{
    //         this.pageLoading = false
    //       }
    //     },
    //     errorResponse => {
    //       this.pageLoading = false
    //       console.log(errorResponse)
    //     }
    //   );
    // },
    // loadItems(){
    //   if(this.page === this.items.length - 1) return
        
    //   const element = this.$refs["end-of-list"] //this.endOfList;
    //   if(!element) return
      
    //   const position = element.getBoundingClientRect();
    //   // checking whether fully visible
    //   if((position.top >= 0 && position.bottom <= window.innerHeight  ) && !this.loading) {
    //       this.loading = true
    //       this.page++
    //       setTimeout(() => {
    //           this.listToDisplay = (this.listToDisplay).concat(this.items[this.page])
    //           this.loading = false
    //           this.loadItems()
    //       }, 500);
    //   }
    // },
    launchGame(){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = ""
        let lang_code = this.getLanguage
        let is_mobile = this.mobileDevice
        this.$store
          .dispatch("user/launchSpadeGaming", { player_id, auth_token,game_code, lang_code, is_mobile })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {     
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    launchDemo(game){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchSpadeGamingDemo", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    }
  }
}
</script>